<template>
  <div class="heading-container">
    <ui-heading tag="h3" no-top-margin>
      {{ $t("mrz_form_heading") }}
    </ui-heading>
    <icon
      v-if="isMrzVerifiedSuccessIcon"
      name="check-circle"
      class="icon success"
    />
    <icon v-else name="alert-circle" class="icon fail" />
  </div>
</template>
<script>
export default {
  props: {
    isMrzVerifiedSuccessIcon: { type: Boolean, default: false }
  }
};
</script>
<style scoped lang="scss">
.heading-container {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
}

.icon {
  &.success {
    fill: var(--text-success);
  }

  &.fail {
    fill: var(--text-danger);
  }
}
</style>
